module.exports = __webpack_public_path__ + "static/img/Gosaas.9e2d505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/Gosaas.png
// module id = zRzm
// module chunks = 150